


























































import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "BasicForm",
})
export default class BasicForm extends Vue {
  private form = {
    name: "",
    region: "",
    date1: "",
    date2: "",
    delivery: false,
    type: [],
    resource: "",
    desc: "",
  };
  private onSubmit() {
    console.log(this.form);
  }
}
